import { useCallback, useContext, useState } from 'react';
import { BackendDispatchContext, BackendStateContext } from '../context/backend-context';
import { useEntityList } from './use-entity-list';

export const useTicketMessageList = (ticketId: string) => {
  const { asyncActions } = useContext(BackendDispatchContext)

  return useEntityList(ticketId, 'ticket-message', asyncActions!.loadTicketMessageList.bind(asyncActions!))
}